Apt.fn.make('account.team-users', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		scope.id = $.context('id');

		LS.api.get('me/teams/' + scope.id, {
			auth: true,
			success: data => {
				data.filters = LS.filters.get();

				$$('detail').html(
					$.view.render($$('template')[0].textContent, data)
				);

				scope.app = Apt.fn.index().init({
					auth: true,
					target: '$users',
					view: $$('usersTemplate')[0].textContent,
					path: `account/teams/${scope.id}`,
					resource: `me/teams/${scope.id}/users`,
					controls: '$controls',
					params: {
						detail: true,
						limit: 20,
						sort: 'name'
					},
					sorting: {
						'name': 'Alphabetical',
						'-newest': 'Newest'
					},
					paginate: true,
					build: filters => {
						if ($$('promoted').prop('checked')) {
							filters.promoted = 1;
						} else {
							delete filters.promoted;
						}
					},
					translate: filters => {
						if (! $$('promoted').prop('checked')) {
							delete filters.promoted;
						}
					}
				}, () => {
					scope.initAction();
				});
			}
		});
	},

	/**
	 * Initialize action
	 */
	initAction() {
		const scope = this;

		$$('userAction').on('input', (e, el) => {
			const action = el.value;
			const app = scope.app.app;
			const $row = $(el).closest('[data-id]');
			const id = $row.data('id');
			const query = {
				'results.id': id
			};

			el.value = '';

			if (action === 'remove') {
				LS.api.delete(`me/teams/${scope.id}/users/${id}`, {
					auth: true,
					namespace: 'team',
					success: () => {
						$row.remove();
					}
				});

				return;
			}

			if (
				action === 'promote' ||
				action === 'demote'
			) {
				const promote = action === 'promote';

				LS.api.request(`me/teams/${scope.id}/users/${id}/promote`, {
					auth: true,
					method: 'patch',
					data: {
						promoted: promote
					},
					namespace: 'team',
					success: () => {
						app.$set(
							['promoted', query], promote
						);
					}
				});

				return;
			}

			if (action === 'role') {
				const current = app.$get(['role', query]).toLowerCase();
				const roles = [
					'user'
				];

				LS.modal.open({
					width: 360,
					model: {
						title: 'Edit role',
						content: $.view.render('account-teams.role', {
							current: current,
							roles: roles
						})
					},
					onShow: () => {
						$$('roleForm').on('submit', (e, el) => {
							const updated = el.role.value;

							LS.modal.confirm(`Change the role from ${current} to ${updated}?`, () => {
								LS.api.request(`me/teams/${scope.id}/users/${id}`, {
									auth: true,
									method: 'patch',
									data: {
										role: updated
									},
									namespace: 'role',
									success: () => {
										app.$set(
											['role', query], LS.util.capitalize(updated)
										);
									}
								});
							});
						}, {
							cancel: true,
							namespace: 'role'
						});
					},
					onHide: () => {
						$.events.reset('role');
					}
				});
			}
		}, {
			delegate: '$detail',
			namespace: 'team'
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('team', this, 'app');
	}
});